import { __awaiter, __rest } from "tslib";
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Form from '@websky/core/src/Checkout/components/Checkout/FormBlockSlot/FormBlockSlot';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import { useSetSsrDataMutation } from '@websky/graphql';
const CheckoutForm = (_a) => {
    var _b;
    var { onFormSubmit } = _a, props = __rest(_a, ["onFormSubmit"]);
    const order = useSelector(getOrder);
    const [setSsrData] = useSetSsrDataMutation();
    const onFormSubmitHandler = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            const passengersWithoutSsr = [];
            const ssrs = [];
            values.passengers.forEach((_a, passengerId) => {
                var { organizationName, personnelNumber } = _a, props = __rest(_a, ["organizationName", "personnelNumber"]);
                if (organizationName || personnelNumber) {
                    const ssrValue = {
                        code: 'OTHS',
                        statusCode: null,
                        travellerIds: [passengerId.toString()],
                        segmentIds: order.flight.segments.map(segment => segment.segment.id)
                    };
                    ssrs.push([
                        Object.assign(Object.assign({}, ssrValue), { description: organizationName }),
                        Object.assign(Object.assign({}, ssrValue), { description: personnelNumber })
                    ]);
                }
                passengersWithoutSsr.push(props);
            });
            const result = yield onFormSubmit(Object.assign(Object.assign({}, values), { passengers: passengersWithoutSsr }));
            if (result) {
                const orderSsrs = ((_c = result.ssrData) === null || _c === void 0 ? void 0 : _c.map(ssr => ({
                    id: ssr.id,
                    code: ssr.ssrCode,
                    statusCode: ssr.status,
                    travellerIds: ssr.travellerIds,
                    segmentIds: ssr.segmentIds,
                    description: ssr.ssrText
                }))) || [];
                if (ssrs.length) {
                    const unionSsrs = [...orderSsrs, ...ssrs.reduce((arr, ssr) => [...arr, ...ssr], [])];
                    yield setSsrData({
                        variables: {
                            parameters: {
                                orderId: order.id,
                                ssrs: unionSsrs
                            }
                        }
                    });
                }
            }
            return result;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    }), [order, (_b = props.orderSubsidyState) === null || _b === void 0 ? void 0 : _b.travellers]);
    return React.createElement(Form, Object.assign({}, props, { onFormSubmit: onFormSubmitHandler }));
};
export default CheckoutForm;
